import { render, staticRenderFns } from "./PracticePatients.vue?vue&type=template&id=59dcefdf&scoped=true&"
import script from "./PracticePatients.vue?vue&type=script&lang=js&"
export * from "./PracticePatients.vue?vue&type=script&lang=js&"
import style0 from "./PracticePatients.vue?vue&type=style&index=0&id=59dcefdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dcefdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCheckbox,VChip,VIcon,VOverlay,VProgressCircular,VSelect})
